<app-nav titulo="Detalles de la oficina" descripcion="Aqui podrá ver toda la información que tenemos acerca de la oficina seleccionada.">
    <div class="office-details">
        <app-office-details-content [office]="office" *ngIf="office"></app-office-details-content>
    </div>
</app-nav>
